import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";


const useStyles = makeStyles((theme) => ({
  textImt: {
    position: "fixed",
    borderRadius: "4px",
    width: "98%",
    zIndex: 1250,
    marginTop:10,
    marginRight: 15,
    marginLeft:15,
  }
}))

export default function TestEnvironment() {
  const classes = useStyles();
  return (
    <div className={classes.textImt}>
      <Alert severity="error"><Typography style={{ fontSize: 15 }}>This is a test environment !</Typography> </Alert>
    </div>
  );
}
